"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _menu = require("./utils/menu");
/**
 * 表关系类
 */
var Relation = /*#__PURE__*/function () {
  function Relation(globalRelationList) {
    (0, _classCallCheck2.default)(this, Relation);
    /**
     * 无极2.0配置的表源关系集
     * [
     *   {
     *     "mainTable": "table1",
     *     "mainField": "field1",
     *     "forkTable": "table2",
     *     "forkField": "field2",
     *     "relation": 1,                         // 1表示1对1、2表示1对多
     *     "isReverse": true,                  // 是否反向关联（无极1.0的link关联模式）
     *   }
     * ]
     */
    this.globalRelationList = globalRelationList;
  }

  /**
   * 获取tableKey表与forkTableKeys表集的关系对象集
   * @param {*} tableKey
   */
  (0, _createClass2.default)(Relation, [{
    key: "getRelationList",
    value: function getRelationList(tableKey) {
      var forkTableKeyList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var tableList = arguments.length > 2 ? arguments[2] : undefined;
      // 找出包含tableKey，另外一个必须是forkTableKeyList存在的关系对象集
      var allRelationList = this.globalRelationList.filter(function (item) {
        return item.mainTable === tableKey || item.forkTable === tableKey;
      }).filter(function (item) {
        return !!forkTableKeyList.find(function (forkTableKey) {
          return forkTableKey === item.mainTable || forkTableKey === item.forkTable;
        });
      });
      var arrayList = [];
      var forkObj = {};
      // 以tableKey为视角【很重要!!!】，找出与其关联 + 存在于forkTableKeyList的关系链
      allRelationList.forEach(function (item) {
        var _tableList$find, _tableList$find2;
        var mainRawPrimaryKey = (_tableList$find = tableList.find(function (table) {
          return table.tableKey === item.mainTable;
        })) === null || _tableList$find === void 0 ? void 0 : _tableList$find.rawPrimaryKey;
        var forkRawPrimaryKey = (_tableList$find2 = tableList.find(function (table) {
          return table.tableKey === item.forkTable;
        })) === null || _tableList$find2 === void 0 ? void 0 : _tableList$find2.rawPrimaryKey;
        var relationType;
        if (item.isReverse) {
          // link关联：mainTable表的关联字段是主键时，关联键值存在右边子表；否则默认左边
          relationType = item.mainField === mainRawPrimaryKey ? _menu.RelationStatus.IN : _menu.RelationStatus.INCLUDE;
        } else {
          // 普通关联：forkTable表的关联字段是主键时，关联键值存在左边；否则默认右边
          relationType = item.forkField === forkRawPrimaryKey ? _menu.RelationStatus.LEFT : _menu.RelationStatus.RIGHT;
        }
        var childTableKey;
        var relation = [];
        var ratio;
        // tableKey表是主关联时
        if (item.mainTable === tableKey) {
          childTableKey = item.forkTable;
          ratio = item.relation;
          relation = [item.mainField, relationType, item.forkField];
        } else {
          // 反转关联关系
          if (relationType === _menu.RelationStatus.IN) {
            relationType = _menu.RelationStatus.INCLUDE;
          } else if (relationType === _menu.RelationStatus.INCLUDE) {
            relationType = _menu.RelationStatus.IN;
          } else if (relationType === _menu.RelationStatus.LEFT) {
            relationType = _menu.RelationStatus.RIGHT;
          } else if (relationType === _menu.RelationStatus.RIGHT) {
            relationType = _menu.RelationStatus.LEFT;
          }
          childTableKey = item.mainTable;
          // 反转的全部当作1对1
          ratio = 1;
          relation = [item.forkField, relationType, item.mainField];
        }

        // 目前不允许两表之间存在两种关联关系
        if (!forkObj[childTableKey]) {
          arrayList.push({
            childTableKey: childTableKey,
            relation: relation,
            isReverse: item.isReverse,
            ratio: ratio,
            rawRatio: item.relation
          });
        }
        forkObj[childTableKey] = true;
      });
      return arrayList;
    }
  }]);
  return Relation;
}();
var _default = Relation;
exports.default = _default;